export class DoctorMessage {   
    IdEmpresa: number;
    IdPersona: number;
    Localizacion: string;

    Email: string;
    NombreCompleto: string;
    Mensaje: string;
    NombreDoctor: string;
    ReCaptchaToken: string;
}